import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";
import Location from "@/Sections/Location";
import LocationExplanation from "@/Sections/LocationExplanation";

const people = [
    {
        name: "Roel - Personal Trainer Uden",
        role: "Gecertificeerd trainer die gespecialiseerd is in onderhouden van jouw resultaten.",
        imageUrl: "/assets/trainers/personal-trainer-roel-alt.jpg",
        imageUrlWebp: "/assets/trainers/webp/personal-trainer-roel-alt.webp",
    },
    {
        name: "Thierry - Personal Trainer Uden",
        role: "Gecertificeerd coach die gespecialiseerd is in de mentale transformaties van onze leden.",
        imageUrl: "/assets/trainers/personal-trainer-thierry-alt.jpg",
        imageUrlWebp: "/assets/trainers/webp/personal-trainer-thierry-alt.webp",
    },
    {
        name: "Tim - Personal Trainer Uden",
        role: "Gecertificeerd coach die gespecialiseerd is in spieropbouw en krachttoename.",
        imageUrl: "/assets/trainers/personal-trainer-tim.jpg",
        imageUrlWebp: "/assets/trainers/webp/personal-trainer-tim.webp",
    },
    {
        name: "Jori - Personal Trainer Uden",
        role: "Gecertificeerd coach die gespecialiseerd is in spieropbouw en krachttoename.",
        imageUrl: "/assets/trainers/personal-trainer-jori.jpg",
        imageUrlWebp: "/assets/trainers/webp/personal-trainer-jori.webp",
    },
];

export default function Home() {
    return (
        <Default>
            <Head>
                <title>Personal Training Uden</title>
                <link rel="canonical" href={route("home")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE is de personaltrainer in omgeving Uden en Schijndel die zorgt voor zowel een fysieke- als mentale transformatie."
                />
                <meta
                    property="og:description"
                    content="WE ARE is de personaltrainer in omgeving Uden en Schijndel die zorgt voor zowel een fysieke- als mentale transformatie."
                />
                <meta property="og:url" content={route("home")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Home - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-3xl sm:text-3xl md:text-7xl lg:text-7xl">
                        Personal training <br /> in Uden
                    </h1>
                    <p className="mt-6 max-w-3xl text-xl text-center mx-auto text-gray-100">
                        Een effectief programma in een unieke sportschool waar
                        je geen nummer bent!
                    </p>
                    <div className="text-center xs:pt-4 sm:pt-4 md:pt-8 pt-16 ">
                        <Link
                            to="location"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Bekijk onze sportschool in Uden
                        </Link>
                    </div>
                </Hero> */}

                <Location location="Uden" />

                <LocationExplanation location="Uden" />

                {/* Stories */}
                <div className="relative sm:p-8 xs:p-8" id="success-stories">
                    <div className="max-w-5xl mx-auto py-16 px-4 xs:py-6 sm:py-24 sm:px-6 lg:px-8">
                        <div className="text-center mb-8">
                            <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-3xl sm:text-4xl md:text-4xl lg:text-5xl">
                                Verhalen van onze leden die Personal Training in
                                Uden volgden
                            </h2>
                        </div>
                        <h2 id="gallery-heading" className="sr-only">
                            Succesverhalen
                        </h2>
                    </div>
                    <iframe
                        width="100%"
                        height="600"
                        src="https://www.youtube.com/embed/eFi5_VaPpb4"
                        title="WE ARE - your physical and mental personal training - reviews"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>

                {/* Our team */}
                <div className="relative mx-auto max-w-7xl xs:py-8 sm:py-8 md:py-16 lg:py-16">
                    <div className="text-center max-w-4xl mx-auto">
                        <h2 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                            Deze Personal trainers staan voor je klaar in Uden!
                        </h2>
                    </div>
                    <ul
                        role="list"
                        className="lg:mt-24 md:mt-12 sm:mt-12 xs:mt-12 space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8"
                    >
                        {people.map((person) => (
                            <li key={person.name} className="ml-0 pl-0">
                                <div className="space-y-4">
                                    <div className="aspect-w-3 aspect-h-2">
                                        <picture>
                                            <source
                                                srcSet={person.imageUrlWebp}
                                                width="384"
                                                height={
                                                    person.name ===
                                                    "Tim - Personal Trainer Uden"
                                                        ? 260
                                                        : 256
                                                }
                                                type="image/webp"
                                                alt="Sportinstructeur personal trainers WE ARE"
                                                className="object-cover shadow-lg rounded-lg"
                                                style={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? { height: "260px" }
                                                        : {}
                                                }
                                            />
                                            <source
                                                srcSet={person.imageUrl}
                                                width="384"
                                                height={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? 260
                                                        : 256
                                                }
                                                type="image/jpeg"
                                                alt="Sportinstructeur personal trainers WE ARE"
                                                className="object-cover shadow-lg rounded-lg"
                                                style={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? { height: "260px" }
                                                        : {}
                                                }
                                            />
                                            <img
                                                src={person.imageUrl}
                                                width="384"
                                                height={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? 260
                                                        : 256
                                                }
                                                alt="Sportinstructeur personal trainers WE ARE"
                                                className="object-cover shadow-lg rounded-lg"
                                                style={
                                                    person.name ===
                                                        "Tim - Personal Trainer Uden" ||
                                                    person.name ===
                                                        "Jori - Personal Trainer Uden"
                                                        ? { height: "260px" }
                                                        : {}
                                                }
                                            />
                                        </picture>
                                    </div>

                                    <div className="space-y-2">
                                        <div className="text-lg text-center leading-6 font-medium space-y-1">
                                            <h3 className="text-white">
                                                {person.name}
                                            </h3>
                                            <p className="text-we-are-yellow">
                                                {person.role}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Success */}
                <div
                    className="relative xs:pb-8 sm:pb-8 md:pb-16 lg:pb-16"
                    id="transformations"
                >
                    <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
                        <div className="text-center">
                            <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                                Succes verhalen en resultaten!
                            </h2>
                            <p className="max-w-2xl mt-5 mx-auto text-xl text-gray-100">
                                Een greep uit onze leden van WE ARE met Personal
                                Training in Uden.
                            </p>
                        </div>
                    </div>

                    <h2 id="gallery-heading" className="sr-only">
                        Transformaties
                    </h2>
                    <ul
                        role="list"
                        className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8"
                    >
                        {[...Array(12)].map((x, i) => (
                            <li className="relative ml-0 p-2 lg:px-4" key={i}>
                                <div
                                    className={
                                        "group block w-full aspect-w-10 aspect-h-10 rounded-lg bg-black"
                                    }
                                >
                                    <picture>
                                        <source
                                            srcSet={`/assets/transformations/webp/personal-training-uden-schijndel-${
                                                1 + i
                                            }.webp`}
                                            width="960"
                                            height="960"
                                            type="image/webp"
                                            alt={"Transformatie " + (1 + i)}
                                            className="object-cover pointer-events-none"
                                        />
                                        <source
                                            srcSet={`/assets/transformations/personal-training-uden-schijndel-${
                                                1 + i
                                            }.jpg`}
                                            width="960"
                                            height="960"
                                            type="image/jpeg"
                                            alt={"Transformatie " + (1 + i)}
                                            className="object-cover pointer-events-none"
                                        />
                                        <img
                                            src={`/assets/transformations/personal-training-uden-schijndel-${
                                                1 + i
                                            }.jpg`}
                                            width="960"
                                            height="960"
                                            alt={"Transformatie " + (1 + i)}
                                            className="object-cover pointer-events-none"
                                        />
                                    </picture>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <div className="text-center">
                        <Link
                            to="contact"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Ik wil dit ook!
                        </Link>
                    </div>
                </div>

                {/* Our location */}
                <div className="relative bg-black lg:p-24" id="location">
                    <div className="max-w-7xl mx-auto px-4 pt-12 sm:px-6 lg:px-8 lg:pt-16 xs:pb-6 sm:pb-6">
                        <div className="sm:h-72 xs:relative sm:relative md:absolute lg:absolute left-0 md:h-full md:w-1/2 xs:w-full sm:w-full">
                            <div className="mapouter">
                                <div
                                    className="gmap_canvas"
                                    style={{
                                        filter: "grayscale(100%) invert(92%) contrast(83%)",
                                    }}
                                >
                                    <iframe
                                        width="100%"
                                        height="600"
                                        id="gmap_canvas"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2474.290671271275!2d5.643470315901894!3d51.67282230641547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c72277f947b67f%3A0xaf815698e6c10517!2sWE%20ARE%20(UDEN)%20-%20Jouw%20transformatie%20binnen%2012%20weken*21!5e0!3m2!1snl!2snl!4v1650990651081!5m2!1snl!2snl"
                                        frameBorder="0"
                                        scrolling="no"
                                        marginHeight="0"
                                        marginWidth="0"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                        <div className="md:ml-auto md:w-1/2 md:pl-10 clear-left relative xs:mt-8 sm:mt-8">
                            <h2 className="xs:text-center sm:text-center block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                                Onze sportschool in Uden
                            </h2>
                            <p className="mt-3 text-lg text-gray-300">
                                Een unieke sportschool in Uden waar onze leden
                                eerst Personal Training volgen om vervolgens de
                                behaalde resultaten onderhouden in onze private
                                gym om een terugval uit te sluiten!
                            </p>
                            <p className="mt-3 text-lg text-gray-300">
                                We zijn nu al benieuwd naar je verhaal en
                                ontvangen je graag in onze sportschool in Uden.
                                Wie weet is de klik op onderstaande knop de
                                verandering van je leven!
                            </p>
                            <div className="xs:text-center sm:text-center">
                                <Link
                                    to="contact"
                                    smooth={true}
                                    offset={0}
                                    duration={500}
                                    className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                                >
                                    Ik wil dit ook!
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
